function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Users");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.7
}, React.createElement("g", {
  id: "users",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M8.75,16 L7.25,16 C6.561,16 6,15.4395 6,14.75 L6,11.25 C6,11.1125 5.888,11 5.75,11 C5.061,11 4.5,10.4395 4.5,9.75 L4.5,6.001 C4.5,5.1735 5.1735,4.5 6.001,4.5 L9.999,4.5 C10.8265,4.5 11.5,5.1735 11.5,6.001 L11.5,9.75 C11.5,10.4395 10.9395,11 10.25,11 C10.1125,11 10,11.1125 10,11.25 L10,14.75 C10,15.4395 9.4395,16 8.75,16 Z M6.001,5.5 C5.725,5.5 5.5,5.725 5.5,6.001 L5.5,9.75 C5.5,9.8875 5.612,10 5.75,10 C6.439,10 7,10.5605 7,11.25 L7,14.75 C7,14.8875 7.112,15 7.25,15 L8.75,15 C8.8875,15 9,14.8875 9,14.75 L9,11.25 C9,10.5605 9.5605,10 10.25,10 C10.3875,10 10.5,9.8875 10.5,9.75 L10.5,6.001 C10.5,5.725 10.2755,5.5 9.999,5.5 L6.001,5.5 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M8,4 C6.897,4 6,3.103 6,2 C6,0.897 6.897,0 8,0 C9.103,0 10,0.897 10,2 C10,3.103 9.103,4 8,4 Z M8,1 C7.4485,1 7,1.4485 7,2 C7,2.5515 7.4485,3 8,3 C8.5515,3 9,2.5515 9,2 C9,1.4485 8.5515,1 8,1 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M13.25,16 L11.5,16 C11.2235,16 11,15.7765 11,15.5 C11,15.2235 11.2235,15 11.5,15 L13.25,15 C13.3875,15 13.5,14.8875 13.5,14.75 L13.5,11.75 C13.5,11.0605 14.0605,10.5 14.75,10.5 C14.8875,10.5 15,10.3875 15,10.25 L15,6.501 C15,6.225 14.7755,6 14.499,6 L13,6 C12.7235,6 12.5,5.776 12.5,5.5 C12.5,5.224 12.7235,5 13,5 L14.499,5 C15.3265,5 16,5.6735 16,6.501 L16,10.25 C16,10.9395 15.4395,11.5 14.75,11.5 C14.6125,11.5 14.5,11.6125 14.5,11.75 L14.5,14.75 C14.5,15.4395 13.9395,16 13.25,16 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M4.5,16 L2.75,16 C2.061,16 1.5,15.4395 1.5,14.75 L1.5,11.75 C1.5,11.6125 1.388,11.5 1.25,11.5 C0.561,11.5 0,10.9395 0,10.25 L0,6.501 C0,5.6735 0.6735,5 1.501,5 L3,5 C3.276,5 3.5,5.224 3.5,5.5 C3.5,5.776 3.276,6 3,6 L1.501,6 C1.225,6 1,6.225 1,6.501 L1,10.25 C1,10.3875 1.112,10.5 1.25,10.5 C1.939,10.5 2.5,11.0605 2.5,11.75 L2.5,14.75 C2.5,14.8875 2.612,15 2.75,15 L4.5,15 C4.776,15 5,15.2235 5,15.5 C5,15.7765 4.776,16 4.5,16 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M13,4.5 C11.897,4.5 11,3.603 11,2.5 C11,1.397 11.897,0.5 13,0.5 C14.103,0.5 15,1.397 15,2.5 C15,3.603 14.103,4.5 13,4.5 Z M13,1.5 C12.4485,1.5 12,1.9485 12,2.5 C12,3.0515 12.4485,3.5 13,3.5 C13.5515,3.5 14,3.0515 14,2.5 C14,1.9485 13.5515,1.5 13,1.5 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M3,4.5 C1.897,4.5 1,3.603 1,2.5 C1,1.397 1.897,0.5 3,0.5 C4.103,0.5 5,1.397 5,2.5 C5,3.603 4.103,4.5 3,4.5 Z M3,1.5 C2.4485,1.5 2,1.9485 2,2.5 C2,3.0515 2.4485,3.5 3,3.5 C3.5515,3.5 4,3.0515 4,2.5 C4,1.9485 3.5515,1.5 3,1.5 Z",
  id: "Shape"
}))));

const SvgUsers = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/users.cc767a15.svg";
export { ForwardRef as ReactComponent };